import { Global } from '../Global';
import { post } from '../utils/ApiUtil';
import './MessageMock';
import {
  ChatRoomDTO,
  ChatRoomUpdateDTO,
  MessageSyncResultDTO,
} from './MessageType';

const syncAllChatRooms = async (
  lastSyncTime: Date,
  readSeqs: { roomId: number; readSeq: number }[],
): Promise<MessageSyncResultDTO | null> => {
  if (Global.isMockMode()) {
    return Global.getMockData('messageSyncAll') as MessageSyncResultDTO;
  }
  const result = await post<
    { lastSyncTime: Date; readSeqs: { roomId: number; readSeq: number }[] },
    MessageSyncResultDTO
  >('/message/syncAllChatRooms', { lastSyncTime, readSeqs }, {
    logTag: 'message:syncAllChatRooms',
  });
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

const appendChatMessage = async (
  roomId: number,
  content: string,
  messageType: string,
): Promise<number | null> => {
  if (Global.isMockMode()) {
    return Date.now();
  }
  const result = await post<
    { roomId: number; content: string; messageType: string },
    number
  >('/message/append', { roomId, content, messageType });
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

const withdrawMessage = async (messageId: number): Promise<boolean> => {
  if (Global.isMockMode()) {
    return true;
  }
  const result = await post<{ messageId: number }, boolean>('/message/withdraw', {
    messageId,
  });
  if (typeof result === 'string') {
    return false;
  }
  return !!result;
};

const addChatRoom = async (params: {
  sellerId: string;
  buyerId: string;
  roomName?: string;
}): Promise<ChatRoomDTO | null> => {
  if (Global.isMockMode()) {
    return Global.getMockData('messageAddRoom') as ChatRoomDTO;
  }
  const result = await post<typeof params, ChatRoomDTO>(
    '/message/addChatRoom',
    params,
  );
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

export const MessageApi = {
  syncAllChatRooms,
  appendChatMessage,
  withdrawMessage,
  addChatRoom,
};

export type { ChatRoomUpdateDTO };
